import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { showError } from "../shared/utils/functions/notification.function";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private router: Router
  ) {}
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
        catchError((x) => this.handleError(x))
        );
    }

    private handleError(err: HttpErrorResponse): Observable<any> {
        if (err.status === 0) {
            showError('' ,'Erro de conexão com o servidor. Verifique sua conexão ou entre em contato com o suporte.');
            return of(err.message);
        }

        if (err.status === 400) {
          const errorBack = err.error?.data?.detalhesErro;

          showError("", errorBack || 'Requisição inválida.');
          return of(err.message);
        }

        if (err.status === 403) {
          const errorBack = err.error?.data?.detalhesErro;
          showError("", errorBack || 'Você não tem permissão para realizar esta ação, entre em contato com seu administrador');
          return of(err.message);
        }

        if (err.status >= 500) {
          showError('' ,'Erro no servidor. Tente novamente mais tarde.');
        }

        return of(err.message);
    }
}
